import React, { createContext, useEffect, useState } from 'react';

export const AuthContextApi = createContext();


const AuthProviderApi = ({ children }) => {

///////////////////////////////// ALL APPLICATION //////////////////////////////////////////
const [AllApplication, setAllApplication] = useState([]);
const [loading, setLoading] = useState(true);

const fetchApplicationApi = async () => {
  try {
    const response = await fetch('https://tutor-tree-server-1.vercel.app/allTutorsLeads/publish');
    const data = await response.json();
    setAllApplication(data.reverse());
    setLoading(false)
  } catch (error) {
    console.error('Error fetching Districts:', error);
  }
};

useEffect(() => {
  fetchApplicationApi();
}, []);

const [AppliedData, setAppliedData] = useState([]);

const updateApplicationLeads = (apply) => {
    setAllApplication(prevLeads => [...prevLeads, apply]);
  };

const fetchAppliedData = async () => {
    try {
        const response = await fetch(`https://tutor-tree-server-1.vercel.app/allTutorsReqJobId`);
        const data = await response.json();
        setAppliedData(data);
    } catch (error) {
        console.error('Error fetching AppliedData:', error);
    }
};

useEffect(() => {
    fetchAppliedData();
}, []);
const [matchedApplications, setMatchedApplications] = useState([]);

useEffect(() => {
  const appliedJobIds = new Set(AppliedData.map(applied => applied.StudentsJobID));
  const matched = AllApplication.filter(app => appliedJobIds.has(app.jobId));
  
  setMatchedApplications(matched);
}, [AppliedData, AllApplication]);


/////////////////// APPLICATION TO SHORTLISTED  START //////////////////////////////////////
  
const [ShortListed, setShortListed] = useState([]);
const [ShortListedLeads, setShortListedLeads] = useState([]); // New state for filtered leads

const fetchArea = async () => {
  try {
    const response = await fetch("https://tutor-tree-server-1.vercel.app/shortlistedData");
    const data = await response.json();
    const reversedData = data.reverse();

    // Filter the reversed data for leads that are cancelled
    const cancelledLeads = reversedData.filter(item => item.leads === "publish");

    setShortListed(reversedData);
    setShortListedLeads(cancelledLeads); // Set the filtered leads
    setLoading(false);
  } catch (error) {
    console.error("Error fetching Districts:", error);
  }
};

useEffect(() => {
  fetchArea();
}, []);

const updateShortListedLeads = (apply) => {
    setShortListedLeads(prevLeads => [...prevLeads, apply]);
};
const removeShortListedLead = (id) => {
    setShortListedLeads(prevLeads => prevLeads.filter(lead => lead._id !== id));
  };
  

/////////////////// APPLICATION TO SHORTLISTED  END //////////////////////////////////////


  const authInfo = {
    ShortListed,
    ShortListedLeads,
    updateShortListedLeads,
    matchedApplications,
    removeShortListedLead,
    updateApplicationLeads
  };

  return (
    <AuthContextApi.Provider value={authInfo}>
      {children}
    </AuthContextApi.Provider>
  );
};

export default AuthProviderApi;
